import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { IResponseWithPagination } from "src/@types/api";
import { IBlog, IBlogCategoty } from "src/@types/blog";

export const BLOG_SLICE_NAME = "blog";
export const ITEMS_PER_PAGE = 6;

interface Params {
  filters: string;
  page?: number;
}

export const getBlogPostsAsync = createAsyncThunk(
  `${BLOG_SLICE_NAME}/fetchBlogPosts`,
  async ({ filters }: Params, { rejectWithValue }) => {
    try {
      const filtersQueryStr = filters ? filters : "page=1";

      const { data } = await instance.get<IResponseWithPagination<IBlog>>(
        `/posts/?${filtersQueryStr}&page_size=${ITEMS_PER_PAGE}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(
        errorText || errorResponsesTrns.gettingBlogPosts
      );

      return rejectWithValue(errorText);
    }
  }
);

export const getBlogCategoriesAsync = createAsyncThunk(
  `${BLOG_SLICE_NAME}/fetchBlogCategories`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IBlogCategoty[]>(`/blog-category/`);

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(
        errorText || errorResponsesTrns.gettingBlogCategories
      );

      return rejectWithValue(errorText);
    }
  }
);
